import {ReactComponent as SichIcon} from "./logo512-3.svg";

const Sichicon = () => {
    return (
        <div className='close_button'><SichIcon className='icon' /></div>
    )
}
export default Sichicon
